"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getEmptyRootContext = getEmptyRootContext;
function getEmptyRootContext() {
  return {
    open: false,
    onOpenChange: () => {},
    dataRef: {
      current: {}
    },
    elements: {
      floating: null,
      reference: null,
      domReference: null
    },
    events: {
      on: () => {},
      off: () => {},
      emit: () => {}
    },
    floatingId: '',
    refs: {
      setPositionReference: () => {}
    }
  };
}